import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import {
    asyncGetParam,
    asyncGetPqrTypeHistorical,
} from '../../../../../services/param.service';
import { Param, ParamHistorical } from '../../../../../shared/types/param';
import { PQR_TYPE } from '../../../../../routes/paths';

export const usePqrTypeDetail = () => {
    const [showHistorical, setShowHistorical] = useState(false);
    const navigate = useNavigate();
    const { idPqrType } = useParams();
    const [loading, setLoading] = useState(false);
    const [pqrType, setPqrType] = useState<Param>();
    const [pqrTypeHistorical, setPqrTypeHistorical] =
        useState<ParamHistorical[]>();

    useEffect(() => {
        if (Boolean(idPqrType)) {
            setLoading(true);
            asyncGetParam(idPqrType)
                .then((pqrType: any) => {
                    if (!pqrType || !pqrType.items) navigate(PQR_TYPE);
                    setPqrType(pqrType?.items);
                })
                .finally(() => setLoading(false));
        }
    }, [idPqrType]);

    useEffect(() => {
        if (showHistorical) {
            setLoading(true);
            asyncGetPqrTypeHistorical(idPqrType)
                .then((resp) => {
                    if (resp) setPqrTypeHistorical(resp);
                })
                .finally(() => setLoading(false));
        }
    }, [showHistorical]);

    return {
        loading,
        pqrType,
        pqrTypeHistorical,
        showHistorical,
        setShowHistorical,
    };
};
